import React, { useEffect, useState, useMemo, useContext } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Axios from '../../axios-proas';
import { useTranslation } from 'react-i18next';
import { getNotyfObject, getArbreJson, checkValidity, getHierarchieBailleur, renameArrayProperties } from '../../shared/utility';
import UsersManagement from '../UsersManagement/UsersManagement';
import { EntContainer, EntContent, EntHeader, EntHeaderActions, EntHeaderTitle, EntHeaderWrapper, NavTabsLi, NavTabsLink, NavTabsUl } from './Entity.styled'
import { useTheme } from 'styled-components';
import Infos from '../../components/Entity/Infos/Infos';
import { PrimaryBtnOutlineAction, CancelBtnOutlineAction, BtnIcon } from '../../styles/Common';
import TableActions from '../../components/UsersManagTable/TableActions/TableActions';
import { SpinnerContainer, TableAction, TableActionLink, TAContainer } from '../../styles/Table.styled';
import { Spinner } from 'react-bootstrap';
import UserFormModal from '../../containers/UserForm/UserForm'
import Campaigns from '../Campaigns/Campaigns'
import AddIcon from '@mui/icons-material/Add';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { AbilityContext } from '../../ability/AbilityContext';
import { createContextualCan } from '@casl/react'

const Can = createContextualCan(AbilityContext.Consumer);

function Entity({ userType, setHierarchieAndNiveaux, updateUserData, campaignsData, sortQuery, reverse, getCampaignsPage, }) {
    let location = useLocation();
    let { uid } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const notyf = getNotyfObject();
    const theme = useTheme();
    const [niveau, setNiveau] = useState([]);
    const [hierarchical, setHierarchical] = useState([]);
    const [newUserModal, setNewUserModal] = useState(false);
    const [entity, setEntity] = useState({ countryCode: "fr", });
    const [tab, setTab] = useState(localStorage.getItem('bailleurActiveTab') || "infos");
    const [update, setUpdate] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [suspendedDocs, setSuspendedDocs] = useState([]);
    const [showSuspendedDocsModal, setShowSuspendedDocsModal] = useState(false);
    const [confirmationUserModalShow, setConfirmationUserModalShow] = useState(false);
    const [userFormData, setUserFormData] = useState({ type: "Bailleur" });
    const [userAdminForUserData, setUserAdminForUserData] = useState([]);
    const [errors, setErrors] = useState(null);
    const [listOfRoles, setListOfRoles] = useState([]);
    const [allBailleurs, setAllBailleurs] = useState([]);
    const [organismes, setOrganismes] = useState([]);

    const [navTabsList, setNavTabsList] = useState([
        { label: 'Informations ', value: 'infos' },
        { label: 'Utilisateurs', value: 'contacts' },
        { label: 'Campagnes', value: 'campagne' },
    ])
    const config = {
        headers: {
            "X-CSRF": "1",
        },
    };

    const ability = useContext(AbilityContext);

    const checkUserFormValidity = (contact) => {
        let errors = []
        if (!contact.hasOwnProperty('raisonSociale') || !checkValidity(contact?.raisonSociale, { required: true })) {
            errors.push(t("masterData:raisonSociale", "Le champ 'Raison sociale' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('libelleCourt') || !checkValidity(contact?.libelleCourt, { required: true })) {
            errors.push(t("masterData:libelleCourt", "Le champ 'Libellé court' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('codeGesCom') || !checkValidity(contact?.codeGesCom, { required: true })) {
            errors.push(t("masterData:codeGesCom", "Le champ 'Code client Younov' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('adresse')) {
            errors.push(t("masterData:adresse", "Le champ 'Adresse' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('url') || !checkValidity(contact?.url, { required: true })) {
            errors.push(t("masterData:url", "Le champ 'URL télédéclaration' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('mentionsCnil') || !checkValidity(contact?.mentionsCnil, { required: true })) {
            errors.push(t("masterData:mentionsCnil", "Le champ 'Mentions CNIL' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('adresseMail') || !checkValidity(contact?.adresseMail, { required: true, isEmail: true })) {
            errors.push(t("masterData:adresseMail", "Le champ 'Adresse courriel' est vide ou non valide"));
        }
        if (contact.hasOwnProperty('telephoneSupport') && contact?.telephoneSupport?.length > 0 && !checkValidity(contact?.telephoneSupport, { isNumeric: true, maxLength: 10, minLength: 10, isTelFax: true })) {
            errors.push(t("masterData:telephoneSupport", "Le champ 'Téléphone du support' est invalide"));
        }
        if (!contact.hasOwnProperty('hotlineMailText') || !checkValidity(contact?.hotlineMailText, { required: true })) {
            errors.push(t("masterData:hotlineMailText", "Le champ 'Texte support téléphonique' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('slsMentionsLegales') || !checkValidity(contact?.slsMentionsLegales, { required: true })) {
            errors.push(t("masterData:slsMentionsLegales", "Le champ 'Mentions légales SLS' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('slsPenalitesMailText') || !checkValidity(contact?.slsPenalitesMailText, { required: true })) {
            errors.push(t("masterData:slsPenalitesMailText", "Le champ 'Pénalités SLS' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('opsMentionsLegales') || !checkValidity(contact?.opsMentionsLegales, { required: true })) {
            errors.push(t("masterData:opsMentionsLegales", "Le champ 'Mentions légales OPS' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('opsPenalitesMailText') || !checkValidity(contact?.opsPenalitesMailText, { required: true })) {
            errors.push(t("masterData:opsPenalitesMailText", "Le champ 'Pénalités OPS' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('adresse') || !checkValidity(contact?.adresse?.ville, { required: true })) {
            errors.push(t("masterData:ville", "Le champ 'Ville' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('adresse') || !checkValidity(contact?.adresse?.codePostal, { required: true, maxLength: 10 })) {
            errors.push(t("masterData:codePostal", "Le champ 'Code postal' est vide ou non valide"));
        }
        if (!contact.hasOwnProperty('metadata') || !checkValidity(contact?.metadata?.codeApe, { maxLength: 5 })) {
            errors.push(t("masterData:codeApe", "Le champ 'Code APE' doit être de type chaîne avec une longueur maximale de « 5 »"));
        }
        if (!contact.hasOwnProperty('metadata') || !checkValidity(contact?.metadata?.numeroTva, { maxLength: 13 })) {
            errors.push(t("masterData:numeroTva", "Le champ 'Numéro TVA' doit être de type chaîne avec une longueur maximale de « 13 »"));
        }
        if (!contact.hasOwnProperty('metadata') || !checkValidity(contact?.metadata?.siret, { maxLength: 14 })) {
            errors.push(t("masterData:siret", "Le champ 'SIRET' doit être de type chaîne avec une longueur maximale de « 14 »"));
        }
        //if (contact.hasOwnProperty('fax') && contact?.fax?.length > 0 && !checkValidity(contact?.fax, { isNumeric: true, minLength: 10, maxLength: 10, isTelFax: true })) {
        //    errors.push(t("masterData:fax", "Le champ Fax est invalide"));
        //}
        if (contact.hasOwnProperty('metadata') && contact?.metadata?.formeJuridiqueSociete?.length > 0 && !checkValidity(contact?.metadata?.formeJuridiqueSociete, { maxLength: 100 })) {
            errors.push(t("masterData:formeJuridiqueSociete", "Le champ 'Forme juridique société doit être d’une longueur maximale de 100 caractères"));
        }

        //if (!contact.metadata.Children.hasOwnProperty('OrderOfLevel') || !checkValidity(contact?.metadata.Children.OrderOfLevel, { required: true })) {
        //    errors.push(t("masterData:error_userEmail", "La liste des 'niveaux hierarchiques' est vide"));
        //} else {
        //    if (!contact.metadata.Children.hasOwnProperty([niveau[0]?.libelle]) || !contact?.metadata?.Children[niveau[0]?.libelle].length>0) {
        //        errors.push(`Veuillez renseigner au moins un ${niveau[0]?.libelle}`);
        //    }
        //}

        return errors;
    }

    const initUserModal = (userUid) => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/users/' + userUid).then((response) => {
            setUserFormData(response?.data?.userDto);
            updateUserData(response?.data)
            setUserAdminForUserData(response?.data?.admins)
            setConfirmationUserModalShow(true);
        }).catch(err => {
            console.log(err);
        })
    }

    const getListBailleur = () => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + `Bailleurs`, {
            params: null,
        }).then(res => {
            let temp = res.data.map((item, index) => {
                return { id: item.id, raisonSociale: item.raisonSociale }
            })
            setAllBailleurs(temp)
        })
    }

    const getAllRoles = () => {
        Axios.get(import.meta.env.VITE_PREFIX_SERVER_IDENTITY + 'CreateUsers/getAllRoles', config).then((response) => {
            setListOfRoles(response.data)
        }).catch(err => {
            console.log(err);
        })
    }

    useEffect(() => {
        if (!uid) {
            localStorage.setItem("bailleurActiveTab", "infos");
            setTab("infos")
        }
    }, [uid])

    useEffect(() => {
        getAllRoles()
        getListBailleur()
        const entityUid = uid;
        if (entityUid) {
            getCampaignsPage(1, null, sortQuery, reverse, 100, entityUid)

            Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs/' + entityUid + '/organismes', {
                params: null,
            },).then((response) => {
                setOrganismes(response?.data)
            }).catch(err => {
                notyf.error("Une erreur s'est produite!");
            })

            Axios.get(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs/' + entityUid, {
                params: null,
            },).then((response) => {
                localStorage.setItem('BailleurId', entityUid);
                let hierarchieBailleur = response?.data?.metadata?.hierarchieBailleur
                const levelTemp = (hierarchieBailleur?.orderOfLevel != null && hierarchieBailleur?.orderOfLevel != "") ? hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } }) : null
                let firsteLevel = hierarchieBailleur?.orderOfLevel?.split('/').map((item, index) => { return { libelle: item } })[0]?.libelle

                setNiveau(levelTemp ? levelTemp : [])
                if (firsteLevel != null && levelTemp != null) {
                    setHierarchical(getHierarchieBailleur(levelTemp, hierarchieBailleur))
                }

                setEntity(response?.data);
                setUpdate(false)
            }).catch(err => {
                notyf.error("Une erreur s'est produite!");
            })
        } else {
            setNavTabsList([
                { label: 'Informations Administratives', value: 'infos' }
            ])
        }

    }, [uid, update])

    useEffect(() => {
        setHierarchieAndNiveaux(hierarchical, niveau, entity?.libelleCourt)
    }, [hierarchical, niveau, entity])

    const changeTab = tab => {
        // if(tab!=="documents"){localStorage.removeItem("show");}
        setTab(tab);
        localStorage.setItem("bailleurActiveTab", tab);
    }

    const handleInputChange = e => {
        if (userType == "ADMIN_YOUNOV") {
            const key = e.target.name;
            var value = e.target.value;
            if (key == "actif") {
                e.target.checked ? value = 1 : value = 0;
            }
            const newEntity = { ...entity, [key]: value };
            setEntity(newEntity);
        }
    }

    const handlePhoneInputChange = e => {
        if (userType == "ADMIN_YOUNOV") {
            const { name, value } = e.target;
            const onlyNumbers = value.replace(/\D/g, "");

            // on ne met à jour que si la valeur est valide 
            if (onlyNumbers === value) {
                const newEntity = { ...entity, [name]: value };
                setEntity(newEntity);
            }
            // ssinon on ignore la saisie
            return;
        }
    }

    const handleFaxInputChange = e => {
        if (userType == "ADMIN_YOUNOV") {
            var value = e;
            const newEntity = { ...entity, fax: value };
            setEntity(newEntity);
        }
    }

    const addEntityclickHandler = () => {
        let temp = hierarchical;
        let level = niveau;
        let levelString = niveau.map((item, index) => { return item.libelle }).join('/');
        let res = getArbreJson(temp, level, entity?.libelleCourt);
        let HierarchieBailleur = { OrderOfLevel: levelString, RootPath: entity?.libelleCourt, children: renameArrayProperties(res) };

        const entityToAdd = { ...entity, metadata: { ...entity.metadata, HierarchieBailleur } }

        let checkErrors = checkUserFormValidity(entityToAdd);
        if (checkErrors && checkErrors.length > 0) {
            setErrors(checkErrors);
        }
        else {
            setErrors([]);
            Axios.post(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs', entityToAdd).then(response => {
                if (response.data) {
                    upsertOrganismes(response.data.id);
                    //console.log(response.data.id);
                    notyf.success("Le bailleur a été créé avec succès");
                    setEntity({});
                    navigate(-1);
                }
            }).catch(response => {
                notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"));
            })
        }
    }

    const upsertOrganismes = (uid) => {
        Axios.post(import.meta.env.VITE_PREFIX_SERVER_API + 'organismes/upsertOrganismes/' + uid, organismes)
        .then(response => {
        }).catch(response => {
            notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"));
        })
    }

    const editEntityclickHandler = () => {
        let temp = hierarchical;
        let level = niveau;
        let levelString = niveau.map((item, index) => { return item.libelle }).join('/');
        let res = getArbreJson(temp, level, entity?.libelleCourt);
        /* let children = JSON.stringify({ OrderOfLevel: levelString, RootPath: entity?.libelleCourt, [niveau[0]?.libelle]: res });*/
        let HierarchieBailleur = { OrderOfLevel: levelString, RootPath: entity?.libelleCourt, children: renameArrayProperties(res) };

        const entityToUpdate = { ...entity, metadata: { ...entity.metadata, HierarchieBailleur } };

        let checkErrors = checkUserFormValidity(entityToUpdate);
        if (checkErrors && checkErrors.length > 0) {
            setErrors(checkErrors);
        } else {
            setErrors([]);
            Axios.put(import.meta.env.VITE_PREFIX_SERVER_API + 'bailleurs', entityToUpdate).then(response => {
                if (response?.data) {
                    //console.log(response?.data);
                    upsertOrganismes(response?.data.id);
                    notyf.success("Le bailleur a été modifiée avec succès");
                }
            }).catch(response => {
                notyf.error(t("mandat:generatedErrorMessage", "Une erreur s'est produite"));
            })
        }
    }

    const saveClickHandler = () => {
        if (entity?.id)
            editEntityclickHandler();
        else
            addEntityclickHandler();
    }

    const deleteEntityClickHandler = () => {

    }

    let tSpinner = showSpinner ? (<>
        <SpinnerContainer style={{ display: "flex", flexDirection: "column" }}>
            <Spinner animation="border" variant="primary" />
            <p>Vérification...</p>
        </SpinnerContainer>
    </>
    ) : null;

    let jSXcontent = null;

    let jsxActions = null;

    switch (tab) {
        case "contacts":
            jsxActions = (<TableActions
                entityUid={uid}
                setConfirmationUserModalShow={setConfirmationUserModalShow}
                setNewUserModal={setNewUserModal}
                listOfRoles={listOfRoles}
                allBailleurs={allBailleurs}
            />)
            jSXcontent = (
                <UsersManagement
                    setConfirmationUserModalShow={setConfirmationUserModalShow}
                    initUserModal={initUserModal}
                    setNewUserModal={setNewUserModal}
                />
            )
            break;
        case "campagne":
            jsxActions = ability.can('add', 'Campagne') &&
                (
                    <TableActionLink
                        style={{ backgroundColor: theme.colors.primary }}
                        to={`/newCampaign/`}
                        state={{ uid: uid, raisonSociale: entity.raisonSociale }}
                    >
                        <span>Nouvelle campagne</span>
                        <BtnIcon>
                            <AddIcon fontSize="small" style={{ color: '#fff' }} />
                        </BtnIcon>
                    </TableActionLink>
                );
            jSXcontent = (
                <Campaigns
                    raisonSociale={entity.raisonSociale}
                    uidBailleur={uid}
                    hierarchical={hierarchical}
                />
            )
            break;

        default:
            jsxActions =
                ability.can('update', 'Bailleur') ? (<>
                    <PrimaryBtnOutlineAction
                        style={{ backgroundColor: theme.colors.success }}
                        onClick={saveClickHandler}
                    >
                        <span> Valider </span>
                    </PrimaryBtnOutlineAction >
                </>) : null

            // c'est ic quil faut ajouter btn supprimer
            jSXcontent = (
                <Infos
                    handlePhoneInputChange={handlePhoneInputChange}
                    handleFaxInputChange={handleFaxInputChange}
                    entity={entity}
                    niveau={niveau}
                    setNiveau={setNiveau}
                    hierarchical={hierarchical}
                    setHierarchical={setHierarchical}
                    handleInputChange={handleInputChange}
                    setEntity={setEntity}
                    userType={userType}
                    hasCampagneAssurance={campaignsData?.some(a => a.type == 1)}
                    cannotBeModified={userType == "ADMIN_YOUNOV" ? false : true}
                    setOrganismes={setOrganismes}
                    organismes={organismes}
                />
            )
            break;
    }

    return (
        <EntContainer>
            <EntHeaderWrapper>
                <EntHeader>
                    <EntHeaderTitle>
                        {uid ? entity?.raisonSociale : "Nouveau bailleur"}
                    </EntHeaderTitle>
                    <EntHeaderActions>
                        {
                            jsxActions
                        }
                        <CancelBtnOutlineAction
                            color={theme.colors.danger}
                            border={theme.colors.danger}
                            onClick={() => navigate(-1)}
                        >
                            Retour
                        </CancelBtnOutlineAction>
                    </EntHeaderActions>
                </EntHeader>
                {
                    errors && errors.length > 0 ? (
                        <div className="alert alert-danger mt-2" role="alert">
                            <ul>
                                {
                                    errors.map(error => (<li key={error}>{error}</li>))
                                }
                            </ul>
                        </div>
                    ) : null
                }
                <NavTabsUl>
                    {
                        navTabsList.map((t, index) => (
                            <NavTabsLi key={{ index }}>
                                <NavTabsLink color={theme.colors.primary}
                                    active={tab === t.value}
                                    onClick={() => changeTab(t.value)}
                                    to={`#`}
                                >
                                    {t.label}
                                </NavTabsLink>
                            </NavTabsLi>
                        ))
                    }
                </NavTabsUl>
            </EntHeaderWrapper>

            <EntContent>
                {tSpinner}
                {jSXcontent}
                {
                    showSuspendedDocsModal && (
                        <SuspendedDocsModal
                            show={showSuspendedDocsModal}
                            closeModal={() => setShowSuspendedDocsModal(false)}
                            documents={suspendedDocs}
                        />
                    )
                }
            </EntContent>

            <UserFormModal
                show={confirmationUserModalShow}
                setConfirmationUserModalShow={setConfirmationUserModalShow}
                title={newUserModal ? "Ajout d'un utilisateur" : "Modification d'un utilisateur"}
                message={``}
                newUserModal={newUserModal}
                contact={!newUserModal ? userFormData : null}
                userAdminForUserData={userAdminForUserData}
                setContact={!newUserModal ? setUserFormData : null}
                uidBailleur={uid}
                hierarchicalTemp={hierarchical}
                niveauTemp={niveau}
                codeBailleur={entity.libelleCourt}
                listOfRoles={listOfRoles}
                entity={entity}
            />
        </EntContainer>
    )
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    login: state.auth.login,
    campaignsData: state.campaigns.data,
    count: state.campaigns.count,
    sortQuery: state.campaigns.sortQuery,
    reverse: state.campaigns.reverse,
})
const mapDispatchToProps = dispatch => ({
    setHierarchieAndNiveaux: (hierarchical, niveaux, RootPath) => dispatch(actions.bailleurSetHierarchieAndNiveaux(hierarchical, niveaux, RootPath)),
    updateUserData: (data) => dispatch(actions.updateUserData(data)),
    getCampaignsPage: (page, filters, sort, reverse, pageSize, uidBailleur) => dispatch(actions.campaignsGetPage(page, filters, sort, reverse, pageSize, uidBailleur)),

})
export default connect(mapStateToProps, mapDispatchToProps)(Entity)
